export default class RequestCache {
    constructor(cacheKey) {
        this.requestCache = {};
        this.cacheKey = cacheKey;
    }

    removeAll() {
        this.requestCache = {};
        sessionStorage.setItem(this.cacheKey, '{}');
    }

    has(key) {
        return this.sessionHas(key) || this.requestHas(key);
    }

    async get(key) {
        if (this.sessionHas(key)) {
            return this.sessionGet(key);
        } else if (this.requestHas(key)) {
            const result = await this.requestGet(key);
            return result;
        }
    }

    async set(key, request) {
        const req = this.requestPromise(request);
        this.requestSet(key, req);
        const result = await req;
        if (result) {
            this.sessionSet(key, result);
        } else {
            this.requestRemove(key);
        }
        return result;
    }

    async remove(key) {
        this.sessionRemove(key);
        if (this.requestHas(key)) {
            const request = this.requestGet(key);
            delete this.requestCache[key];
            await request;
            this.sessionRemove(key);
        }
    }

    sessionHas(key) {
        const data = JSON.parse(sessionStorage.getItem(this.cacheKey));
        return !!data?.[key];
    }

    sessionGet(key) {
        const data = JSON.parse(sessionStorage.getItem(this.cacheKey));
        return data?.[key];
    }

    sessionSet(key, value) {
        const data = JSON.parse(sessionStorage.getItem(this.cacheKey)) || {};
        data[key] = value;
        sessionStorage.setItem(this.cacheKey, JSON.stringify(data));
    }

    sessionRemove(key) {
        const data = JSON.parse(sessionStorage.getItem(this.cacheKey)) || {};
        delete data[key];
        sessionStorage.setItem(this.cacheKey, JSON.stringify(data));
    }

    requestHas(key) {
        return !!this.requestCache[key];
    }

    requestGet(key) {
        return this.requestCache[key];
    }

    requestSet(key, request) {
        return this.requestCache[key] = request;
    }

    requestRemove(key) {
        delete this.requestCache[key];
    }

    async requestPromise(request) {
        try {
            const response = await request;
            if (response.ok) {
                const result = await response.json();
                return result;
            }
        } catch (err) {
            console.error(err);
        }
    }
}
